module.exports = __webpack_public_path__ + "img/pitch-football.png";